export const siteContent = {
  company: {
    email: "info@6th.sg",
  },
  hero: {
    headline: "Venture investing and building for the next horizon",
    subhead:
      "Singapore-based and globally focused, we look beyond the immediate to where the infrastructure of tomorrow’s digital economy is being forged. We are hands-on builders and high-conviction investors backing early-stage founders positioned to benefit from current and future trends.",
    bullets: [
      "Early-stage, high-conviction investing",
      "Hands-on builders: thesis, strategy, and execution support",
      "Global mandate with Singapore roots",
    ],
  },
  thesis: {
    eyebrow: "Thesis",
    title: "Early-stage conviction across three lanes",
    description:
      "We invest early in companies positioned to benefit from structural shifts in technology, markets, and regulation. Our focus spans deep tech (including AI), enterprise software, and fintech.",
    areas: [
      {
        id: "deep-tech-ai",
        title: "Deep Tech + AI",
        summary:
          "Frontier capabilities and enabling infrastructure: applied AI, tooling, data advantage, and defensible technical moats.",
        icon: "Cpu",
      },
      {
        id: "enterprise-sw",
        title: "Enterprise Software",
        summary:
          "Workflow and platform software with clear buyers, strong ROI, and distribution-led compounding.",
        icon: "Building2",
      },
      {
        id: "fintech",
        title: "Fintech",
        summary:
          "Products shaped by regulation, rails, and behavior. We build for trust, compliance, and durable unit economics.",
        icon: "Landmark",
      },
    ],
  },
  services: {
    eyebrow: "Services",
    title: "Two ways we partner",
    tracks: [
      {
        id: "investment",
        title: "Investment",
        description:
          "Our unique offering to founders includes:",
        bullets: [
          "Founder friendly",
          "Tech, product and go to market expertise",
          "Team of ex-founders and operators",
          "Access to network of founders and funds",
        ],
      },
      {
        id: "consulting",
        title: "Consulting",
        description:
          "Our unique offering for consulting engagements includes:",
        bullets: [
          "Expertise across the entire lifecycle from idea inception to scaling",
          "Track record of delivering projects with real world impact",
          "Strong senior team with extensive product, tech and go to market background",
          "Bespoke implementations that fits your unique needs",
        ],
      },
    ],
  },
  portfolio: {
    eyebrow: "Portfolio",
    title: "Portfolio highlights",
    description:
      "A selection of investments and hands-on engagements across deep tech, enterprise software, and fintech.",
    tabs: [
      {
        key: "investments",
        label: "Investments",
        items: [
          {
            name: "Atomionics",
            sector: "Deep Tech",
            note: "Quantum sensing technology revolutionizing resource exploration and navigation.",
          },
          {
            name: "Six Sense",
            sector: "Industrial AI",
            note: "AI-driven quality control and predictive maintenance for manufacturing.",
          },
          {
            name: "Propseller",
            sector: "PropTech",
            note: "Tech-powered real estate agency offering a reliable, data-driven way to sell properties.",
          },
          {
            name: "Cormint",
            sector: "Infrastructure",
            note: "Sustainable Bitcoin mining infrastructure using immersion cooling technology.",
          },
          {
            name: "HyBird",
            sector: "Robotics",
            note: "Advanced robotic inspection and digitization solutions for industrial assets.",
          },
        ],
        pastInvestments: ["Polymarket", "Anthropic", "Web3Auth", "Vauban"],
      },
      {
        key: "services",
        label: "Services",
        items: [
          {
            name: "Algorithmic Liquidity Engine",
            sector: "DeFi",
            note: "Architected automated market making strategies to provide sustainable liquidity depth for illiquid long-tail digital assets.",
          },
          {
            name: "High-Frequency Data Pipeline",
            sector: "Infrastructure",
            note: "Re-engineered ingestion architectures to improve throughput, latency, and scale for a major financial data provider.",
          },
          {
            name: "Blockchain API Optimization",
            sector: "Infrastructure",
            note: "Optimized RPC aggregation and caching layers to significantly reduce response times for a high-volume blockchain data provider.",
          },
          {
            name: "Statistical Arbitrage System",
            sector: "Trading",
            note: "Built an end-to-end low-latency trading infrastructure for capturing cross-exchange inefficiencies in digital asset markets.",
          },
          {
            name: "Smart Contract Protocol",
            sector: "Smart Contracts",
            note: "End-to-end development and deployment of secure, gas-optimized Solidity smart contracts for DeFi protocols.",
          },
          {
            name: "DApp Architecture",
            sector: "Web3",
            note: "Full-stack development of user-facing decentralized applications, including wallet integration and frontend interaction layers.",
          },
        ],
      },
    ],
  },
};
